import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../../ApiGenericResponse";
import { ApiResponse } from "../../ApiResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../../Command";

export class DownloadMFAInstructions extends Command {
    endPoint: string = API_PREFIX + API_VERSION + "/usermanagement";
    httpVerb: HttpVerbType = "get";
    username: string;

    constructor(username: string) {
        super();
        this.responseType = "blob";
        this.endPoint += `/${username}/mfa/download`;
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand();
    }
}
